module.exports = __webpack_public_path__ + "img/logo.e135efd3.png";